import React, { useEffect, useState } from "react";
import { Switch, Button, Modal, Form as AntForm, message } from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Form, MainTable } from "components";
import { instance } from "utils/axios";
import fields from "./fields";

function WoundMaterial() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [form] = AntForm.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------- API ----------------
  const fetchData = async () => {
    setLoading(true);
    instance({
      method: "get",
      url: "/wound/materials",
    })
      .then((res) => {
        const rows = res?.data || [];
        setData(rows);
        setFilteredData(rows); // MainTable энэ state-ийг хэрэглэж байгаа тул хэвээр үлдээв
      })
      .catch((err) => {
        console.error(err);
        message.error("Өгөгдөл татахад алдаа гарлаа!");
      })
      .finally(() => setLoading(false));
  };

  const handleSubmit = async (values) => {
    console.log("sfdsfdsfd")
    setLoading(true);
    const isEdit = !!editData;
    const method = isEdit ? "put" : "post";
    const url = isEdit ? `/wound/material/${editData.id}` : "/wound/material";

    instance({ method, url, data: values })
      .then(() => {
        message.success("Амжилттай хадгалагдлаа");
        fetchData();
        handleCloseModal();
      })
      .catch((err) => {
        console.error(err);
        message.error("Хадгалах явцад алдаа гарлаа!");
      })
      .finally(() => setLoading(false));
  };

  const handleChangeActive = (id, checked) => {
    modal.confirm({
      title: checked ? "Идэвхтэй болгох уу?" : "Идэвхгүй болгох уу?",
      content: "Тохиргооны төлөвийг өөрчлөх гэж байна.",
      okText: "Тийм",
      cancelText: "Үгүй",
      onOk: () => {
        instance({
          method: "put",
          url: `/wound/material/active/${id}`,
          data: { isActive: checked },
        })
          .then(() => fetchData())
          .catch((err) => {
            console.error(err);
            message.error("Төлөв солих үед алдаа гарлаа!");
          });
      },
    });
  };
  // ------------- END API --------------

  const handleEdit = (row) => {
    setEditData(row);
    form.setFieldsValue(row);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setEditData(null);
    form.resetFields();
  };

  // анхны код дахь тайлбартай багануудыг нэр өөрчлөлтгүй, энгийн render-ээр үлдээлээ
  const columns = [
    { title: "№", dataIndex: "id", key: "id", width: 50 },
    { title: "Нэр", dataIndex: "name", key: "name" },
    {
      title: "Төлөв",
      dataIndex: "isActive",
      key: "isActive",
      width: 150,
      filters: [
        { text: "Идэвхтэй", value: true },
        { text: "Идэвхгүй", value: false },
      ],
      onFilter: (value, record) => record.isActive === value,
      render: (text, row) => (
        <div className="flex gap-2 ">
          <Switch
            checked={!!text}
            onChange={(checked) => handleChangeActive(row.id, checked)}
          />
          <p>{text ? "Идэвхтэй" : "Идэвхгүй"}</p>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (_, row) => (
        <Button size="small" onClick={() => handleEdit(row)}>
          <EditOutlined /> Засах
        </Button>
      ),
    },
  ];

  return (
    <div className="flex flex-col px-4 pb-4">
      {/* Шүүлтүүр хэсэг байхгүй — таны хүсэлтээр утгуудыг өөрчлөхгүй */}
      <div className="flex items-center gap-2 mb-4">
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          className="ml-4"
          onClick={() => setOpen(true)}
        >
          Нэмэх
        </Button>
      </div>

      <MainTable
        dataTable={filteredData}
        columns={columns}
        loading={loading}
        pagination={true}
        setCurrentPage={setCurrentPage}
        title="Материал бүртгэл"
      />

      <Modal
        title={editData ? "Материал засах" : "Материал нэмэх"}
        open={open}
        onCancel={handleCloseModal}
        onOk={form.submit}
        confirmLoading={loading}
        destroyOnClose
        width={600}
        okText="Хадгалах"
      >
        <Form
          form={form}
          fields={fields(editData)}
          layout="vertical"
          onFinish={handleSubmit}
          editData={editData}
          className="gap-4"
        />
      </Modal>

      {contextHolder}
    </div>
  );
}

export default WoundMaterial;
